import React, { useEffect } from 'react'
import { useWindowDimensions, ScrollView, View } from 'react-native'
import tailwind from 'tailwind-rn'
import { useMediaQuery } from 'react-responsive'

import { SafeAreaView } from 'react-native-safe-area-context'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'

export default function FormRDConexo( { route }) {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height

useEffect(() => {
    new RDStationForms('formulario-de-inscricao-co-nexo-612b67828ea97e0dcd6b', 'UA-67881880-4').createForm()
}, [])

      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="INSCRIÇÃO" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-10 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
              <View style={[tailwind('mx-5'), {marginTop: isLargeScreen ? 110 : 150}]}>
                    <div role="main" id="formulario-de-inscricao-co-nexo-612b67828ea97e0dcd6b"></div>
            </View>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
